export default __webpack_public_path__ + "static/media/0034.076cc1b7.png";